import ssfRest from '../np-rest/ssfRest';

const restEdit = props => {
    const [SSFRest] = ssfRest(props);
    return [SSFRest]
}

export default restEdit;